module.exports = __webpack_public_path__ + "2a3de8c8e7b569760b9b1f6267fa17b9.pdf";